"use client"

import * as React from "react"
import { format } from "date-fns"
import { ja } from 'date-fns/locale' // 日本語ロケールをインポート
import { Calendar as CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"

import { cn } from "@/shared/lib/utils"
import { Button } from "@/shared/ui/button"
import { Calendar } from "@/shared/ui/calendar"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/shared/ui/popover"

interface DatePickerWithRangeProps extends React.HTMLAttributes<HTMLDivElement> {
     
    dateRange: DateRange | undefined;
    onDateChange: (date: DateRange | undefined) => void;
    disabled?: boolean; // 親から無効状態を受け取れるようにする
}

export function DatePickerWithRange({
    className,
    dateRange,
    onDateChange,
    disabled,
}: DatePickerWithRangeProps) {
    return (
        <div className={cn("grid gap-2", className)}>
            <Popover>
                <PopoverTrigger asChild>
                    <Button
                        id="date"
                        variant={"outline"}
                        className={cn(
                            "w-full justify-start text-left font-normal", // 幅を100%に
                            !dateRange && "text-muted-foreground"
                        )}
                        disabled={disabled} // disabled プロパティを適用
                    >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {dateRange?.from ? (
                            dateRange.to ? (
                                <>
                                    {format(dateRange.from, "PPP", { locale: ja })} -{" "}
                                    {format(dateRange.to, "PPP", { locale: ja })}
                                </>
                            ) : (
                                format(dateRange.from, "PPP", { locale: ja })
                            )
                        ) : (
                            <span>期間を選択</span>
                        )}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        initialFocus
                        mode="range"
                        defaultMonth={dateRange?.from}
                        selected={dateRange}
                        onSelect={onDateChange}
                        numberOfMonths={2}
                        locale={ja} // カレンダーに日本語ロケールを適用
                        disabled={disabled} // カレンダー自体も無効化
                    />
                </PopoverContent>
            </Popover>
        </div>
    )
} 